import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
} from "@mui/material";
import { FullWidthField } from "@poseidon/ui/components/form/FullWidthField";
import { Field, useFormikContext } from "formik";
import { RadioGroup } from "formik-mui";
import { getBooleanValue } from "@poseidon/utils/getBooleanValue";
import { MultiLineFullWidthField } from "@poseidon/ui/components/form/MultiLineFullWidthField";
import { NationalitiesField } from "./NationalitiesField";
import { CountriesField } from "./CountriesField";
import * as Yup from "yup";
import { useMemo } from "react";
import { EditSailorFormPanel } from "./EditSailorFormPanel";

export function TaxFieldsInner({ readonly }) {
  const { values } = useFormikContext();

  const hasDualNationality = getBooleanValue(values.hasDualNationality);
  const hasOtherTaxResidency = getBooleanValue(values.hasOtherTaxResidency);

  return (
    <>
      <Grid container spacing={2} mt={0}>
        <Grid item xs={12}>
          <FormControl disabled={readonly}>
            <FormLabel>Is sailor a dual national?</FormLabel>
            <Field
              component={RadioGroup}
              name="hasDualNationality"
              sx={{ display: "flex", flexDirection: "row" }}
            >
              <FormControlLabel
                value={null}
                control={<Radio />}
                label="Unanswered"
                checked={
                  hasDualNationality === "" || hasDualNationality === null
                }
              />
              <FormControlLabel
                value={true}
                control={<Radio />}
                checked={hasDualNationality === true}
                label="Yes"
              />
              <FormControlLabel
                value={false}
                control={<Radio />}
                checked={hasDualNationality === false}
                label="No"
              />
            </Field>
          </FormControl>
        </Grid>
      </Grid>

      <Grid container spacing={2} mt={0}>
        <Grid item xs={12} sm={6}>
          <NationalitiesField label="Nationality" name="nationality" />
        </Grid>
        {hasDualNationality && (
          <Grid item xs={12} sm={6}>
            <NationalitiesField
              label="Additional Nationality"
              name="additionalNationality"
            />
          </Grid>
        )}
      </Grid>

      <Grid container spacing={2} mt={4}>
        <Grid item xs={12} sm={6}>
          <FormControl disabled={readonly}>
            <FormLabel>
              Does sailor have tax residency other than the UK?
            </FormLabel>
            <Field
              component={RadioGroup}
              name="hasOtherTaxResidency"
              sx={{ display: "flex", flexDirection: "row" }}
              margin="none"
            >
              <FormControlLabel
                value={null}
                control={<Radio />}
                label="Unanswered"
                checked={
                  hasOtherTaxResidency === "" || hasOtherTaxResidency === null
                }
                margin="none"
              />
              <FormControlLabel
                margin="none"
                value={true}
                checked={hasOtherTaxResidency === true}
                control={<Radio />}
                label="Yes"
              />
              <FormControlLabel
                margin="none"
                value={false}
                checked={hasOtherTaxResidency === false}
                control={<Radio />}
                label="No"
              />
            </Field>
          </FormControl>
        </Grid>
      </Grid>
      {hasOtherTaxResidency && (
        <Grid container spacing={2} mt={0}>
          <Grid item xs={12} sm={6}>
            <CountriesField label="Tax Residency" name="taxResidency" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Field
              component={FullWidthField}
              name="taxIdentityNumber"
              label="Tax Identity Number"
              margin="none"
            />
          </Grid>
        </Grid>
      )}

      <Grid container spacing={2} mt={4}>
        <Grid item xs={12}>
          <Field
            component={MultiLineFullWidthField}
            label="Source of Deposit"
            name="sourceOfDeposit"
          />
        </Grid>
      </Grid>
    </>
  );
}

const sailorDefaults = {
  hasDualNationality: null,
  additionalNationality: "",
  hasOtherTaxResidency: null,
  taxIdentityNumber: "",
  sourceOfDeposit: "",
};

export const validationSchema = Yup.object().shape({
  //todo: validation
});

const mapValues = (values) => {
  return {
    ...values,
    hasDualNationality: getBooleanValue(values.hasDualNationality),
    hasOtherTaxResidency: getBooleanValue(values.hasOtherTaxResidency),
  };
};
export function TaxFields({ sailor, readonly }) {
  const initialValues = useMemo(
    () => ({
      ...sailorDefaults,
      ...sailor,
    }),
    [sailor]
  );
  return (
    <EditSailorFormPanel
      title="Nationality &amp; Tax Details"
      disabled={readonly}
      initialValues={initialValues}
      mapValues={mapValues}
      validationSchema={validationSchema}
      sailor={sailor}
    >
      <TaxFieldsInner readonly={readonly} />
    </EditSailorFormPanel>
  );
}
